import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Text, Heading, Spinner, Grid } from "grommet";
import { useNavigate } from "react-router-dom";
import API_URL from "../config/config";
import { useParams } from "react-router-dom";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { LinkPrevious } from "grommet-icons";
import AssessmentCard from "../components/ManagerPortal/AssessmentCard";
import moment from "moment-timezone";

const UserManagerAssessmentDetails = () => {
  const { user_id } = useParams();
  const [assessmentResult, setAssessmentResult] = useState([]);
  const [skillsData, setSkillsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the assessment result
    const fetchAssessmentData = async () => {
      try {
        const result = await axios.get(
          `${API_URL}/dashboard/checkquiz/${user_id}`,
        );
        console.log("Assessment data:", result.data.assessmentResult);

        const userTimeZone = moment.tz.guess();
        // Adjust the due_by based on timezone difference
        const validAssessments = result.data.assessmentResult.map(
          (assessment) => {
            // If the received timezone (tz) is different from the user's timezone
            if (assessment.tz !== "NULL" && assessment.tz !== userTimeZone) {
              // Convert the due_by field to the user's timezone
              const convertedDueBy = moment
                .tz(assessment.due_by, assessment.tz)
                .clone()
                .tz(userTimeZone)
                .format("YYYY-MM-DD HH:mm:ss"); // Format to match your display format
              return {
                ...assessment,
                due_by: convertedDueBy, // Replace the due_by with the converted time
              };
            }
            return assessment;
          },
        );
        if (validAssessments) {
          setAssessmentResult(validAssessments.reverse());
        }
        console.log("Assessment data:", result.data.assessmentResult);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching assessment data:", error);
      }
    };

    // Fetch skills data to map topic IDs to names
    const fetchSkillsData = async () => {
      const result = await axios.get(`${API_URL}/user/getRolesAndSkills`);
      setSkillsData(result.data.sub_product_skills);
    };

    fetchAssessmentData();
    fetchSkillsData();
  }, [user_id]);

  // Helper to find skill name by topic ID
  const getTopicName = (topicId) => {
    const skill = skillsData.find((skill) => skill.id === topicId);
    return skill ? `${skill.product_name} - ${skill.skill_name}` : null;
  };

  if (!assessmentResult) {
    return (
      <Box pad="medium">
        <Text>Loading...</Text>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box fill align="center" justify="center">
        <Spinner size="large" />
        <Text>Loading...</Text>
      </Box>
    );
  }

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box
          pad={{ top: "medium", horizontal: "medium" }}
          direction="row"
          justify="between"
          align="center"
        >
          <LinkPrevious
            onClick={() => navigate(-1)}
            color="brand"
            size="medium"
            style={{ cursor: "pointer" }}
          />
          <Heading
            level="1"
            margin={{ horizontal: "medium", bottom: "xsmall" }}
            textAlign="left"
            style={{ flex: 1 }}
          >
            Manager Created Assessments
          </Heading>
          {/* Add a placeholder Box to balance the layout if needed */}
          <Box width="small" />
        </Box>
        <Box pad="medium" overflow="auto" margin={{ horizontal: "large" }}>
          {/* Page Heading and Brand Line */}
          <Text
            size="medium"
            color="dark-5"
            margin={{ bottom: "small", top: "xsmall" }}
          >
            We recommend you to take these assessments assigned by your manager
            to enhance your skills and complete your learning path.
          </Text>
          <Box
            border={{ color: "brand", size: "xsmall" }}
            width="100%"
            margin={{ bottom: "medium" }}
          />

          {/* DataTable Container */}
          <Box pad="small" margin={{ bottom: "medium" }}>
            <Grid columns={{ count: 3, size: "auto" }} gap="medium">
              {assessmentResult
                .slice() // Clone the array to avoid mutating original data
                .sort((a, b) => new Date(a.due_by) - new Date(b.due_by)) // Sort based on due_by (earliest first)
                .map((assessment) => (
                  <AssessmentCard
                    key={assessment.assesment_id}
                    assessment={assessment}
                    getTopicName={getTopicName}
                    user_id={user_id}
                    assessment_id={assessment.assesment_id}
                    manager_id={assessment.manager_id}
                  />
                ))}
            </Grid>
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default UserManagerAssessmentDetails;
